export const TEST_ID = 'coverageOptionsSection';

export const TITLE = 'Coverage Options';

export const LABELS = {
    cornerFill: 'Corner Fill',
    coverageArea: 'Coverage Area',
    headlandOrder: 'Headland Order',
    headlandPasses: 'Headland Passes'
};

export const HEADLAND_PASSES = { max: 10, min: 0, step: 1 };

export const HEADLAND_ORDER_OPTIONS = [
    { label: 'Before Passes', value: 'BEFORE_PASSES' },
    { label: 'After Passes', value: 'AFTER_PASSES' }
];

export const COVERAGE_AREA_OPTIONS = [
    { label: 'Route Only', value: 'ROUTE_ONLY' },
    { label: 'Boundary Only', value: 'BOUNDARY_ONLY' },
    { label: 'Route & Boundary', value: 'ROUTE_AND_BOUNDARY' }
];

export const CORNER_FILL_OPTIONS = [
    { label: 'Off', value: 'OFF' },
    { label: 'On', value: 'ON' }
];

export const CORNER_FILL_ON_VALUE = 'ON';

export const CORNER_FILL_ON_INDEX = 1;

export const CORNER_FILL_OFF_INDEX = 0;
